import { render, staticRenderFns } from "./Usage-Extended.vue?vue&type=template&id=cbb4752c&lang=pug"
import script from "./Usage-Extended.vue?vue&type=script&lang=ts"
export * from "./Usage-Extended.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports